import React from 'react';

import { SigningInSpinner } from '../authentication/components/loginSpace/SigningInSpinner';
import { PKCEStore } from './PKCEStore';

const LOGIN_URL = '/vizportal/api/clientxml/auth/pkce';

export interface PKCELoginProps {
  authorizationCode: string;
  host?: string;
}

export const PKCELogin: React.FunctionComponent<PKCELoginProps> = props => {
  const sanitizedHost = isOnlineHost(props.host) ? props.host : null;
  React.useEffect(
    () => {
      let didCancel = false;

      PKCEStore.getCodeVerifier()
        .then(codeVerifier => !didCancel && sendLoginRequest(props.authorizationCode, codeVerifier, sanitizedHost));

      return () => didCancel = true;
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <SigningInSpinner/>;
};

function isOnlineHost(host: string) {
  return host && (host.endsWith('online.tableau.com') || host.endsWith('tabint.net'));
}

// This looks weird for a reason. This code would be expected to run inside a WebView component
// embedded into Tableau Mobile. The WebView would be displaying a document loaded from, say
// the online.tableau.com domain. But the server that issued the authorizationCode could be a
// different domain, say, us-east-1.online.tableau.com. We need to POST the code to the right
// server, so we have to get creative.
function sendLoginRequest(authorizationCode: string, codeVerifier: string, sanitizedHost?: string) {
  const url = sanitizedHost
    ? window.location.protocol + '//' + sanitizedHost + LOGIN_URL
    : LOGIN_URL;

  const params: { [index: string]: string } = {
    authorization_code: authorizationCode,
    code_verifier: codeVerifier,
  };

  // Use a form to send a POST request and navigate to the URL of the endpoint simultaneously. This API responds with
  // a redirect, so the resulting flow contains two different navigation events.
  const form = document.createElement('form');
  form.method = 'post';
  form.action = url;
  for (const key in params) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = params[key];
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
}
